import { IApplicationState } from '../../types/redux';
import { ERooms } from '../../types/rooms';

const ROOM_TO_QUERY_MAP: { [key in ERooms]: string[] } = {
  [ERooms.One]: ['room1'],
  [ERooms.Two]: ['room2'],
  [ERooms.Three]: ['room3'],
  [ERooms.FourPlus]: ['room4', 'room5', 'room6'],
};

export function selectListingUrl(state: IApplicationState) {
  const {
    fieldsState: { flatPrice, rooms },
    regionId,
  } = state;

  const queryRaw: { [key: string]: unknown } = {
    offer_type: 'flat',
    deal_type: 'sale',
    region: regionId,
    maxprice: flatPrice,
  };

  const roomsQueryParams = ROOM_TO_QUERY_MAP[rooms];
  for (const qp of roomsQueryParams) {
    queryRaw[qp] = 1;
  }

  const query = Object.entries(queryRaw)
    .filter(([, value]) => value != null)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return `/cat.php?${query}`;
}
